import { render, staticRenderFns } from "./FaqQuestionAnswer.vue?vue&type=template&id=e0531984&scoped=true&"
import script from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FaqQuestionAnswer.vue?vue&type=style&index=0&id=e0531984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0531984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0531984')) {
      api.createRecord('e0531984', component.options)
    } else {
      api.reload('e0531984', component.options)
    }
    module.hot.accept("./FaqQuestionAnswer.vue?vue&type=template&id=e0531984&scoped=true&", function () {
      api.rerender('e0531984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/FaqQuestionAnswer.vue"
export default component.exports